module.exports = __webpack_public_path__ + "static/media/module_home_ibd.39bc74ea.png";